const AuthStatus = () => null;

export default AuthStatus;
